<div class="form-container" *ngIf="addGuestForm">
    <div class="header-container">
        <h5>{{ title }}</h5>
        <div class="action-buttons">
            <button type="button"
                   class="button secondary"
                    (click)="cancelGuest()">
                Cancel
            </button>
            <button
                type="button"
                class="button primary add-button"
                [disabled]="isAddAvailable"
                (click)="submit()">
                {{ buttonSubmitTitle }}
            </button> 
        </div>
    </div>
    <div class="add-guest-container">
        <div class="photo-upload-container" *ngIf="!isBadgeExtension">
            <img [src]="userPhotoUrl ? userPhotoUrl : defaultImageUrl" alt="" class="photo-preview">
            <span class="info-row">
                Photo guide
                <employee-info-hint [isHTML]="true" infoText="
                     <div>
                        <strong> Please, follow the rules for a better result </strong>
                        <div> 1.Jpeg/jpg format</div>
                        <div> 2. Forward-facing with your entire face, head, shoulders, and eyes completely visible</div>
                        <div> 3. Clear, well-lit photo of only you</div>
                        <div> 4. Plain white or off-white background</div>
                        <div> 5. No sunglasses or hats</div>
                        <div> 6. No black and white photos</div>
                        <div> 7. Maximum size of file is 10 Mbs</div>
                    </div>">
                </employee-info-hint>
            </span>
            <ui-upload-photo
                [uploadConfig]="uploadConfig"
                [buttonType]="'text'"
                [buttonText]="buttonTitle"
                [isVisitorRequest]="true"
                (onUploadPhoto)="onPhotoUploaded($event)"
            >
            </ui-upload-photo>
        </div>

        <div [formGroup]="addGuestForm" class="add-guest-inputs">

            <div class="input-container">
                <employee-request-input title="First name" formControlName="firstName"></employee-request-input>
                <employee-request-input title="Last name" formControlName="lastName"></employee-request-input>
                <employee-request-input
                    title="Mobile number"
                    placeholder="+91-0000-0000-00"
                    formControlName="phoneNumber"></employee-request-input>
                <employee-request-input title="Email" type="email"
                                        formControlName="emailAddress"></employee-request-input>
                <employee-request-input title="Company" formControlName="company"></employee-request-input>

                <div>
                    <p class="mb-4"><strong>Visa type</strong></p>
                    <ui-dropdown-simple
                        [keyName]="'name'"
                        [valueName]="'id'"
                        [optionsList]="visaTypes"
                        [selectedValue]="selectedVisaType"
                        [placeholder]="'Select'"
                        [showListOnTop]="true"
                        (valueChange)="onVisaTypeChange($event)">
                    </ui-dropdown-simple>
                </div>

                <div>
                    <employee-entity-fss (valueChange)="onEntityFssChange()"></employee-entity-fss>
                </div>

                <div class="input-block">
                    <employee-visit-reason  *ngIf="showVisitReason" (visitReasonChange)="onVisitReasonChange()"></employee-visit-reason>
                </div>
            </div>
            <div class="input-container">

                <div class="input-block">
                    <employee-access-required (accessRequiredChange)="onAccessRequiredChange($event)"></employee-access-required>
                </div>

                <div class="input-block">
                    <employee-approvers
                        title ="Approver(sr. manager and above)"
                        [selectedApprovers]="addGuestForm?.value?.approversFull"
                        [isFunctionRequired]="true"
                        [employeeFunctionId]="addGuestForm?.value?.entityOrFssId"
                        [requestCategory]="BadgeRequestCategoryEnum.MemberFirm"
                        [disabled]="isSeniorManager"
                        (approversChanged)="setApprovers($event)"
                        (approversFullChanged)="setFullApprovers($event)"
                    ></employee-approvers>
                </div>


            </div>


            <div class="input-container">
                <div class="input-block">
                    <employee-request-input
                        title="Visit start"
                        type="date"
                        minValue="today"
                        formControlName="visitStart"
                        (change)="dateChanged()"
                    ></employee-request-input>
                </div>
                <div class="input-block">
                    <employee-request-input
                        title="Visit end"
                        type="date"
                        formControlName="visitEnd"
                        [disabled]="!minDate || addGuestForm.controls.visitStart.invalid"
                        [minValue]="minDate"
                        [noOfDays]="DisplayDate"
                        (change)="dateChanged()"
                    ></employee-request-input>
                </div>
                <div class="input-block">
                    <strong>No of days</strong>
                    <div class="mtb-8">
                        <span>{{ numOfDays ? numOfDays : '-' }}</span>
                    </div>
                </div>
                <div class="input-block">
    <p class="mb-4">
        <strong>Attachment </strong><span>(optional)</span>
    </p>
    
    <!-- Upload button - always visible -->
    <ui-upload-photo
        [uploadConfig]="uploadAttachmentConfig"
        [buttonType]="'label'"
        [buttonText]="'Add Attachment'"
        [isVisitorRequest]="true"
        [isAttachment]="true"
        (onUploadPhoto)="onAttachmentUpload($event)"
    >
    </ui-upload-photo>
    
    <!-- List of attachments -->
    <div class="attachments-list" *ngIf="attachmentsList.length > 0">
        <div class="attachment-container" *ngFor="let attachment of attachmentsList; let i = index">
            <span class="attachment-title ellipsis">{{ attachment.name }}</span>
            <div class="secondary-text">
                <span class="attachment-title">{{ attachment.length | fileSize }} </span>
                <i class="icon icon-delete" (click)="clearAttachment(i)"></i>
            </div>
        </div>
    </div>
</div>
            </div>
            <div class="notification-container">
                <employee-request-textarea
                    title="Comments (optional)"
                    formControlName='notification'
                ></employee-request-textarea>
            </div>
        </div>
    </div>

</div>
